import { getInstance } from './axiosFactory';
import { raiseError } from './globalActions';
import axios from "axios";
const axiosInstance = getInstance();

export function loadModulesSuccess(modules) {
  return { type: 'LOAD_MODULES', modules };
}
export function loadAllModulesByCompanySuccess(modules) {
  return { type: 'LOAD_MODULES_BY_COMPANY', modules };
}

export function loadAllPatient(patient) {
  // console.log("patient in action", patient)
  return { type: 'LOAD_PATIENT', patient };
}

export function loadUserModulesSuccess(modules) {
  return { type: 'LOAD_USER_MODULES', modules };
}

export function loadSelectedModule(selectedModule) {
  return { type: 'MODULE_SELECTED', selectedModule };
}
export function loadSelectedModuleVersion(selectedModuleVersion) {
  return { type: 'MODULE_VERSION_SELECTED', selectedModuleVersion };
}
export function loadSelectedModuleCompany(selectedModuleCompany) {
  return { type: 'MODULE_COMPANY_SELECTED', selectedModuleCompany };
}

export const selectedModule = (selectedModule) => {
  return (dispatch) => {
    dispatch(loadSelectedModule(selectedModule));
  };
};

export const selectedModuleVersion = (selectedModuleVersion) => {
  return (dispatch) => {
    dispatch(loadSelectedModuleVersion(selectedModuleVersion));
  };
};

export const selectedModuleCompany = (selectedModuleCompany) => {
  return (dispatch) => {
    dispatch(loadSelectedModuleCompany(selectedModuleCompany));
  };
};
export const addModule = (token, moduleData) => {
  return axiosInstance.post('/module/addmodule', moduleData, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const modifyModule = (token, data) => {
  return axiosInstance.post('/module/modifymodule', data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const addVersion = (token, data) => {
  return axiosInstance.post('/module/addversion', data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const modifyVersion = (token, data) => {
  return axiosInstance.post('/module/modifyversion', data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const addAssignCompany = (token, data) => {
  return axiosInstance.post('/module/addassigncompany', data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const getAllModules = (token, pageNumber, pageSize) => {
  return (dispatch) => {
    axiosInstance
      .post('/module/getallmodules',
        { pageSize, pageNumber },
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
      .then((res) => dispatch(loadModulesSuccess(res.data.modules)))
      .catch((err) => dispatch(raiseError(err)));
  };
};

export const fetchModules = (pageNumber, pageSize, sortOrder, sortColumn) => {
  return axiosInstance
    .post("/module/getallmodules", { pageSize, pageNumber, sortOrder, sortColumn })
};

export const validateImportModuleFile = (
  token,
  file,
  companyId,
  userShouldChangePasswordAtFirstLogin
) => {
  let formData = new FormData();
  formData.append('fileName', file);
  formData.append(
    'userShouldChangePasswordAtFirstLogin',
    userShouldChangePasswordAtFirstLogin
  );
  formData.append('companyId', companyId);
  return axiosInstance.post('/account/validateFile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      authorization: 'Bearer ' + token,
    },
  });
};

export const processImportModulesFile = (token, fileId) => {
  return axiosInstance.post(
    '/account/importfile',
    { fileId: fileId },
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );
};

export const getUserModules = (token) => {
  return (dispatch) => {
    fetchUserModules(token)
      .then((res) => dispatch(loadUserModulesSuccess(res.data)))
      .catch((err) => dispatch(raiseError(err)));
  };
}

export const fetchUserModules = (token) => {
  return axiosInstance
    .get('/module/getusermodules', {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });

}

export const modifyAssignCompany = (token, data) => {
  return axiosInstance.post('/module/modifyassigncompany', data, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
}

export const getAllModulesByCompany = (token, companyId) => {
  return (dispatch) => {
    axiosInstance
      .post("/module/getallmodulesbycompany", { companyId }, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => dispatch(loadAllModulesByCompanySuccess(res.data)))
      .catch((err) => dispatch(raiseError(err)));
  };
}
export const fetchAllModulesByCompany = () => {
  return axiosInstance
    .post("/module/getallmodulesbycompany", {});
}
export const assignModulesToAllCompanyUsers = (modules) => {
  return axiosInstance.post('/module/assignmodulestoallCompanyusers', { modules: modules }
  );
}

export const getModuleCompetencies = (moduleid) => {
  return axiosInstance.get(`/module/getmodulecompetencies?moduleid=${moduleid}`);
}

export const getAllPatientList = () => {
  // console.log("axiosInstance",axiosInstance)
  return (dispatch) => {
    console.log("axiosInstance",axiosInstance)
   axiosInstance.get(`/GetAllNewPatient`)
  .then((res) => dispatch(loadAllPatient(res.data)));
  }
}

export const getIntentsByPid = (pid) => {
  const datavalue = {
            id: pid,
            key: "Not"
        }
  return axiosInstance.post('/getIntentsByPid', datavalue, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}